import React from "react";
import {Button, Form, Input, Alert, Checkbox, Divider} from "antd";
import {Link} from "react-router-dom";
import CircularProgress from "../components/CircularProgress";
import {injectIntl} from "react-intl";
import Context from "../Context";
import credentialToken from "./../api/credentials";
import token from "./../api/token";
import {Helmet} from "react-helmet";
import Flex from "../util/Flex";

const FormItem = Form.Item;
const authImmediate = false;

class SignUp extends React.Component {
  static contextType = Context;

  constructor(props) {
    super(props);

    const appConfig = window.appConfig || {};

    this.config = {
      ...appConfig,
    };

    this.state = {
      error: false,
      success: false,
      pending: false,
    };
  }

  m = (key) => {
    const {intl} = this.props;
    return intl.formatMessage({id: "signup." + key});
  };

  save = async (data) => {
    this.setState({pending: true, error: false, success: false});
    let result = await this.context.api.q(
      "/sign/up",
      {
        username: data.login,
        email: data.email,
        password: data.password,
      },
      {exact: true},
      credentialToken.getAccess()
    );

    if (result.id) {
      if (authImmediate) {
        let authResult = await this.context.api.q(
          "/oauth2/token",
          {
            grant_type: "password",
            username: data.login,
            password: data.password,
          },
          {exact: true},
          false,
          true
        );
        if (authResult.access_token) {
          token.set(
            authResult.access_token,
            null,
            authResult.expires_in,
            authResult.session
          );
        }
        document.location.href = "/";
      } else {
        this.setState({success: true, pending: false});
      }
    } else {
      if (result.hasOwnProperty("error")) {
        this.setState({error: result.error.message});
      }
      this.setState({pending: false});
    }
  };

  g = () => {
    let googleOAuth2Endpoint = new URL(
      "https://accounts.google.com/o/oauth2/v2/auth"
    );
    let params = {
      client_id: window.appConfig.googleClientId,
      redirect_uri: window.appConfig.apiDomain + "/oauth2/code/google",
      scope: "openid profile email",
      response_type: "code",
      access_type: "online",
      include_granted_scopes: true,
      prompt: "select_account",
      state: window.appConfig.state || "SignIn",
    };

    for (let k in params)
      googleOAuth2Endpoint.searchParams.append(k, params[k]);

    document.location.href = googleOAuth2Endpoint;
  };

  render() {
    const {pending, error, success} = this.state;
    const mConfirmInvalid = this.m("password.confirm.invalid");

    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                <img src={"/assets/images/sbg.png"} alt="OCPP CS"/>
              </div>
              <div className="gx-app-logo-wid">
                <Helmet>
                  <title>{this.m("signup")}</title>
                </Helmet>
                <h1>{this.m("signup")}</h1>
                <p>{this.m("text")}</p>
              </div>
              <div className="gx-app-logo">
                <img alt="example" src="/assets/images/logo.png"/>
              </div>
            </div>

            <div className="gx-app-login-content">
              {success ? (
                <div>
                  <Alert message={this.m("success")} type="success"/>
                  <Link to="/">{this.m("mainpage")}</Link>
                </div>
              ) : (
                <Form
                  name="basic"
                  onFinish={this.save}
                  onFinishFailed={null}
                  className="gx-signin-form gx-form-row0"
                >
                  {this.config.googleAuthorize ? (
                    <FormItem>
                      <Button style={{width: "100%"}} onClick={this.g}>
                        <Flex>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M19.9895 10.1871C19.9895 9.36767 19.9214 8.76973 19.7742 8.14966H10.1992V11.848H15.8195C15.7062 12.7671 15.0943 14.1512 13.7346 15.0813L13.7155 15.2051L16.7429 17.4969L16.9527 17.5174C18.879 15.7789 19.9895 13.221 19.9895 10.1871Z"
                              fill="#4285F4"
                            ></path>
                            <path
                              d="M10.1993 19.9313C12.9527 19.9313 15.2643 19.0454 16.9527 17.5174L13.7346 15.0813C12.8734 15.6682 11.7176 16.0779 10.1993 16.0779C7.50243 16.0779 5.21352 14.3395 4.39759 11.9366L4.27799 11.9466L1.13003 14.3273L1.08887 14.4391C2.76588 17.6945 6.21061 19.9313 10.1993 19.9313Z"
                              fill="#34A853"
                            ></path>
                            <path
                              d="M4.39748 11.9366C4.18219 11.3166 4.05759 10.6521 4.05759 9.96565C4.05759 9.27909 4.18219 8.61473 4.38615 7.99466L4.38045 7.8626L1.19304 5.44366L1.08875 5.49214C0.397576 6.84305 0.000976562 8.36008 0.000976562 9.96565C0.000976562 11.5712 0.397576 13.0882 1.08875 14.4391L4.39748 11.9366Z"
                              fill="#FBBC05"
                            ></path>
                            <path
                              d="M10.1993 3.85336C12.1142 3.85336 13.406 4.66168 14.1425 5.33717L17.0207 2.59107C15.253 0.985496 12.9527 0 10.1993 0C6.2106 0 2.76588 2.23672 1.08887 5.49214L4.38626 7.99466C5.21352 5.59183 7.50242 3.85336 10.1993 3.85336Z"
                              fill="#EB4335"
                            ></path>
                          </svg>
                          <div className="gx-ml-2">{this.m("google")}</div>
                        </Flex>
                      </Button>
                      <Divider plain>
                        {this.m("or")}
                      </Divider>
                    </FormItem>
                  ) : null }

                  <FormItem
                    rules={[
                      {required: true, message: this.m("username.invalid")},
                    ]}
                    name="login"
                  >
                    <Input placeholder={this.m("username")}/>
                  </FormItem>

                  <FormItem
                    name="email"
                    rules={[
                      {
                        required: true,
                        type: "email",
                        message: this.m("email.invalid"),
                      },
                    ]}
                  >
                    <Input placeholder={this.m("email")}/>
                  </FormItem>

                  <FormItem
                    name="password"
                    rules={[
                      {required: true, message: this.m("password.invalid")},
                    ]}
                  >
                    <Input.Password placeholder={this.m("password")}/>
                  </FormItem>

                  <FormItem
                    name="passwordconfirm"
                    dependencies={["password"]}
                    rules={[
                      {
                        required: true,
                        message: this.m("password.confirm.empty"),
                      },
                      ({getFieldValue}) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error(mConfirmInvalid));
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      suffix={null}
                      placeholder={this.m("password.confirm")}
                    />
                  </FormItem>

                  <Form.Item
                    name="iaccept"
                    valuePropName="checked"
                    rules={[
                      {
                        validator: (_, value) =>
                          value
                            ? Promise.resolve()
                            : Promise.reject(
                              new Error(this.m("iaccept.invalid"))
                            ),
                      },
                    ]}
                  >
                    <Checkbox>
                      {this.m("iaccept")}{" "}
                      <Link to="/terms">{this.m("terms")}</Link>
                    </Checkbox>
                  </Form.Item>

                  {error && <Alert message={error} type="error"/>}

                  <FormItem>
                    <Button
                      type="primary"
                      className="gx-mb-0"
                      htmlType="submit"
                    >
                      {this.m("signup")}
                    </Button>
                    <span>{this.m("or")}</span>{" "}
                    <Link to="/signin">{this.m("signin")}</Link>
                  </FormItem>
                </Form>
              )}
            </div>

            {pending && (
              <div className="gx-loader-view">
                <CircularProgress/>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SignUp);
